import { Apple, Award, Bell, Calendar, CalendarDays, Camera, CheckCircle, Medal, Play, Search, Trophy, UserPlus, Video } from "lucide-react"

export function JugarSection() {
  return (
    <section id="jugar" className="pt-2 pb-8 md:pb-16 px-4">
      <div className="text-center mb-6">
        {/* Download CTA */}
        <div className="mb-2">
          <p className="text-base sm:text-lg font-bold text-orange-700">
            ¡Ya podés descargar tu aplicación hoy!
          </p>
          <p className="text-sm text-muted-foreground mb-4">
            Sumate a la comunidad y encontrá tu próximo partido, entrenador o torneo.
          </p>
        </div>

        {/* Store badges */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <a
            href="https://apps.apple.com/ar/app/jugar-hoy/id6755086713"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-xl bg-black px-5 py-3 text-white shadow-md hover:bg-gray-900 hover:scale-105 active:scale-100 transition-all min-w-[200px]"
          >
            <div className="flex h-9 w-9 items-center justify-center">
              <Apple className="h-7 w-7" fill="white" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-[11px] uppercase tracking-wide opacity-80">Descargar en</span>
              <span className="text-base font-semibold">App Store</span>
            </div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=dev.jugarhoy"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-xl bg-black px-5 py-3 text-white shadow-md hover:bg-gray-900 hover:scale-105 active:scale-100 transition-all min-w-[200px]"
          >
            <div className="flex h-9 w-9 items-center justify-center">
              <Play className="h-6 w-6" fill="white" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-[11px] uppercase tracking-wide opacity-80">Disponible en</span>
              <span className="text-base font-semibold">Google Play</span>
            </div>
          </a>
        </div>

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-orange-300 to-transparent" />
          <div className="flex items-center gap-2 text-lg">
            <span>🎾</span>
            <span>⚽</span>
            <span>🏀</span>
            <span>🏊</span>
            <span>🏋️</span>
            <span>🏃</span>
          </div>
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-orange-300 to-transparent" />
        </div>

        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold font-display mb-3">
          Arma tus partidas de la semana
        </h2>
        <div className="inline-block bg-[#EA580C] text-white rounded-full px-4 py-2 text-sm sm:text-base font-bold mb-4">
          ¿ TE FALTA 1 PARA JUGAR HOY ? 🏋️‍♂️🎾🏀
        </div>

        <div className="mt-3 text-left bg-white/10 p-3 sm:p-4 rounded-lg">
          <p className="text-sm sm:text-base">
            Si buscas nuevos desafios, armar tu partida semanal, queres competir o necesitas entrenar con los
            mejores profes tenes que sumarte!
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-2xl border border-orange-100 bg-white/80 backdrop-blur-sm p-4 text-card-foreground shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <h3 className="text-lg font-bold font-display mb-3">Tu partido semanal</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <CalendarDays className="h-4 w-4 text-[#EA580C]" />
                <span>Confirma asistencia cada semana!</span>
              </li>
              <li className="flex items-center gap-2">
                <Bell className="h-4 w-4 text-[#EA580C]" />
                <span>
                  <strong>¿ Te Falta 1 ? </strong> Alerta relampago!
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Camera className="h-4 w-4 text-[#EA580C]" />
                <span>Subi fotos, videos y comparti!</span>
              </li>
              <li className="flex items-center gap-2">
                <Video className="h-4 w-4 text-[#EA580C]" />
                <span>Vivi tu partida grabada!</span>
              </li>
            </ul>
          </div>
          <div className="rounded-2xl border border-orange-100 bg-white/80 backdrop-blur-sm p-4 text-card-foreground shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <h3 className="text-lg font-bold font-display mb-3">Encontra competidores ya!</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <UserPlus className="h-4 w-4 text-[#EA580C]" />
                <span>Crea tu perfil deportivo y sumate a tu club</span>
              </li>
              <li className="flex items-center gap-2">
                <Calendar className="h-4 w-4 text-[#EA580C]" />
                <span>Arma tu agenda y te enviamos competidores!</span>
              </li>
              <li className="flex items-center gap-2">
                <Bell className="h-4 w-4 text-[#EA580C]" />
                <span>
                  Acepta las alertas de <strong>Falta 1</strong>
                </span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-[#EA580C]" />
                <span>No pierdas tu reserva y divertite!</span>
              </li>
            </ul>
          </div>
          <div className="rounded-2xl border border-orange-100 bg-white/80 backdrop-blur-sm p-4 text-card-foreground shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <h3 className="text-lg font-bold font-display mb-3">Competi y mejora</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Search className="h-4 w-4 text-[#EA580C]" />
                <span>Busca a tu entrenador favorito!</span>
              </li>
              <li className="flex items-center gap-2">
                <Trophy className="h-4 w-4 text-[#EA580C]" />
                <span>Entrena y subi de categoria</span>
              </li>
              <li className="flex items-center gap-2">
                <Award className="h-4 w-4 text-[#EA580C]" />
                <span>Sumate a torneos de tus clubes</span>
              </li>
              <li className="flex items-center gap-2">
                <Medal className="h-4 w-4 text-[#EA580C]" />
                <span>Competi en las asociaciones oficiales!</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
